module.exports = __webpack_public_path__ + "img/phone.04a90fe2.svg";